import React from 'react';
import { defaultSizeValue } from "../constants";
export var SizeControlContext = /*#__PURE__*/React.createContext({
  size: defaultSizeValue
});
SizeControlContext.displayName = 'SizeContext';
SizeControlContext.__KONTUR_REACT_UI__ = 'SizeContext';